<template>
  <form
    id="niceForm"
    method="post"
    target="popupChk"
    action="https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb"
  >
    <input type="hidden" name="m" value="checkplusService" />
    <input type="hidden" name="EncodeData" id="encodeData" />
    <button
      type="button"
      class="btn btn--blue"
      @click="openNicePopup"
      v-bind="$attrs"
    >
      {{ title }}
    </button>
  </form>
</template>

<script>
import { inject } from "vue";
import dc from "@/component/DataChk.js";
export default {
  props: {
    title: {
      type: String,
      default: "본인 인증하기",
    },
    type: {
      // 회원가입시 권한필요하여 사용
      type: String,
      default: null,
    },
    childName: {
      // 회원가입시 만 14세미만 인증용
      type: String,
      default: null,
    },
    childPhone: {
      // 회원가입시 만 14세미만 인증용
      type: String,
      default: null,
    },
  },
  emits: ["success"],
  setup(props, { emit }) {
    const axios = inject("axios");

    // methods 정의
    const openNicePopup = () => {
      if (props.type === "CHILD-REPORT") {
        if (!dc.nullChk(props.childName)) {
          alert("만 14세 미만 인증 시 자녀의 이름을 입력하십시오");
          return;
        }

        if (!dc.telValidChk(props.childPhone)) {
          alert(
            "만 14세 미만 인증 시 자녀의 휴대전화 번호를 정확히 입력하십시오"
          );
          return;
        }
      }
      window.open(
        "",
        "popupChk",
        "width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no"
      );
      axios
        .post("/core/pu/common/nice/get", {
          type: props.type,
          childName: props.childName,
          childPhone: props.childPhone,
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            document.getElementById("encodeData").value = res.data.resMsg;
            document.getElementById("niceForm").submit();
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        });
      // 3. 팝업에서 메시지 받기 (인증 성공)
      window.addEventListener("message", async (event) => {
        if (event.data && event.data.status === "NICE_AUTH_SUCCESS") {
          const refId = event.data.refId;
          emit("success", refId); // emit으로 부모에 refId 전달
        }
      });
    };

    // html에서 사용될 데이터 정의
    return {
      openNicePopup,
    };
  },
};
</script>